import type { IconData } from '@stacksjs/iconify-core'

export const hardDrive2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 37c0-1.331-.106-2.66-.317-3.975L40.86 9.197c-.5-3.123-2.822-5.562-5.975-5.82C32.382 3.172 28.84 3 24 3s-8.381.172-10.885.377c-3.153.258-5.474 2.697-5.975 5.82L3.317 33.025A25 25 0 0 0 3 37\"/><path d=\"M3 37c0 4.405 3.58 7.727 7.984 7.847C14.126 44.932 18.386 45 24 45s9.874-.068 13.016-.153C41.42 44.727 45 41.405 45 37s-3.58-7.727-7.984-7.847A484 484 0 0 0 24 29c-5.614 0-9.874.068-13.016.153C6.58 29.273 3 32.595 3 37m35 0H18m-7 0h-1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default hardDrive2
